import { useId, type ComponentProps, type ReactNode } from "react";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import Text from "./Text";
import style from "./Checkbox.module.css";

type CheckboxStandaloneProps = Omit<ComponentProps<"input">, "type"> & {
  children?: ReactNode;
  pillStyle?: boolean;
};

export default function CheckboxStandalone({
  children,
  pillStyle,
  className,
  disabled,
  ...props
}: CheckboxStandaloneProps) {
  const id = useId();
  return (
    <div
      className={classnames(
        className,
        pillStyle ? style.pillStyle : style.checkbox,
      )}
    >
      <input id={id} type="checkbox" disabled={disabled} {...props} />
      <Text
        as="label"
        htmlFor={id}
        className={classnames(disabled && style.disabled)}
      >
        {children}
      </Text>
    </div>
  );
}
